module.exports = __webpack_public_path__ + "img/invest.a26ca822.jpg";